import { noop } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { artifactRecentRevisionsQuery } from '@/features/artifacts/queries';
import { ProjectArtifactHeader } from '@/features/artifacts/components/artifact-header';
import { ArtifactDetailPage } from '@/features/artifacts/components/artifact-detail-page';

export const Route = createFileRoute('/_authed/project/$projectId/artifacts/$artifactId/')({
  component: RouteComponent,
  loader: ({ context, params }) => {
    context.queryClient.query(artifactRecentRevisionsQuery(params.artifactId)).catch(noop);
  },
});

function RouteComponent() {
  const { artifactId } = Route.useParams();

  return (
    <>
      <ProjectArtifactHeader />
      <ArtifactDetailPage artifactId={artifactId} />
    </>
  );
}
